import styles from './index.module.scss';

interface Props {
    children: any;
    type: 'buy' | 'more';
    onClick: Function;
    disabled?: boolean;
}

const Button: React.FC<Props> = (props) => {
    const className = props.type === 'buy' ? styles.Button : styles.ButtonLearnMore;
    return (
        <div className={`${className}${props.disabled ? ` ${styles.disabled}` : ''}`} onClick={() => !props.disabled && props.onClick && props.onClick()}>
            {props.children}
        </div>
    );
};

export default Button;
